//#region src/utils/response/constants.ts
const X_ALREADY_SENT = "x-hono-already-sent";

//#endregion
export { X_ALREADY_SENT as t };